var map = {
	"./legals/about-us.md": [
		6459,
		[
			459
		]
	],
	"./legals/contact-us.md": [
		8152,
		[
			152
		]
	],
	"./legals/disclaimer.md": [
		1092,
		[
			92
		]
	],
	"./legals/faq.md": [
		7776,
		[
			395
		]
	],
	"./legals/privacy.md": [
		8379,
		[
			379
		]
	],
	"./legals/terms.md": [
		9952,
		[
			952
		]
	],
	"./product/direct-storage.md": [
		5195,
		[
			195
		]
	],
	"./product/introduction.md": [
		7630,
		[
			630
		]
	],
	"./product/mtproto.md": [
		1577,
		[
			577
		]
	],
	"./product/quickstart.md": [
		35,
		[
			35
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4182;
module.exports = webpackAsyncContext;